import styled from '@emotion/styled'

export const CalendarSettingsPanelButtonsWrapper = styled.div`
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  display: flex;
  justify-content: center;
  padding: 12px;
`

export const DaySettingsButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;
  margin: 0 8px;
  min-width: 58px;

  &:hover {
    background-color: #f1f3f4;
    cursor: pointer;
  }
`

export const DaySettingsButtonText = styled.p`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  margin: 0;
  opacity: 1;
  text-transform: none;
`
